"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fourteen/sections/bannerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode, useRef } from "react";

type BannerSectionBannerSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-lg-7 col-xl-6" | "col-xl-6" */
    className: string;
    /** Detected variants: "Skin that" | "Reveal" */
    h10Text: ReactNode;
    /** Detected variants: "With" | "Radiant" */
    h10H10Text: ReactNode;
    /** Detected variants: "Glows" | "Natural" */
    span0Text: ReactNode;
    /** Detected variants: "Confidence" | "Skin" */
    span1Text: ReactNode;
    /** Detected variants: "Schedule Visit Now" | "Explore Services" */
    link0Text: ReactNode;
    /** Detected variants: "Expert dermatological care combining medical precision with a deep understanding of how your skin affects how you feel." | "Personalized skincare solutions from certified dermatology specialists for acne, pigmentation, aging, and more." */
    p0Text: ReactNode;
    /** Detected variants: "col-lg-5 col-xl-6" | "col-xl-6" */
    div1ClassName: string;
    /** Detected variants: "banner-img" | "banner-img wow fadeInUp" */
    div0ClassName: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "/Templates/Doccure/img/banner/skin-banner-01.png" | "/Templates/Doccure/img/banner/skin-banner-02.png" */
    src: string;
    /** Detected variants: "banner-slide" */
    divClassName?: string;
    /** Detected variants: "container" */
    div0ClassName2?: string;
    /** Detected variants: "row align-items-end" */
    div0ClassName3?: string;
    /** Detected variants: "banner-content wow fadeInUp" */
    div0ClassName4?: string;
    /** Detected variants: "0.2s" */
    div0DataWowDelay?: string;
    /** Detected variants: "1s" */
    div0DataWowDuration?: string;
    /** Detected variants: "section-line" */
    span0ClassName?: string;
    /** Detected variants: "subtitle" */
    span1ClassName?: string;
    /** Detected variants: "btn btn-secondary theme-14-btn" */
    link0ClassName?: string;
    /** Detected variants: "all_routes.register" */
    href?: string;
    /** Detected variants: "isax isax-calendar-tick5 me-2" */
    i0ClassName?: string;
    /** Detected variants: "banner" */
    alt?: string;
    /** Detected variants: "img-fluid banner-image" */
    imageWithBasePath0ClassName?: string;
    bannerWrapItems?: BannerSectionBannerTwosItem[];
    bannerWrapItems2?: BannerSectionBannerTwos2Item[];
};

type BannerSectionBannerTwosItem = {
    key: Key | null | undefined;
    /** Detected variants: "%" | "K+" | "+" */
    h20Text: ReactNode;
    /** Detected variants: "Customers Satisfaction" | "Sessions Completed" | "Type of Services" */
    p0Text: ReactNode;
    /** Detected variants: "banner-item-two" */
    className?: string;
    /** Detected variants: "count-digit" */
    span0ClassName?: string;
    /** Detected variants: "mb-0" */
    p0ClassName?: string;
    /** Detected variants: "isVisible && (\n                        <CountUp className=\"number\" end={98} duration={2} />\n                      )" | "isVisible && (\n                        <CountUp className=\"number\" end={8} duration={2} />\n                      )" | "isVisible && (\n                        <CountUp className=\"number\" end={40} duration={2} />\n                      )" */
    h20span0Expr0: ReactNode;
};

type BannerSectionBannerTwos2Item = {
    key: Key | null | undefined;
    /** Detected variants: "%" | "K+" | "+" */
    h20Text: ReactNode;
    /** Detected variants: "Customers Satisfaction" | "Sessions Completed" | "Type of Services" */
    p0Text: ReactNode;
    /** Detected variants: "banner-item-two" */
    className?: string;
    /** Detected variants: "mb-0" */
    p0ClassName?: string;
    /** Detected variants: "isVisible && (\n                        <CountUp className=\"number\" end={95} duration={2} />\n                      )" | "isVisible && (\n                        <CountUp className=\"number\" end={8} duration={2} />\n                      )" | "isVisible && (\n                        <CountUp className=\"number\" end={40} duration={2} />\n                      )" */
    h20Expr0: ReactNode;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false, // we’ll use custom external buttons
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

export type HomeFourteenBannerSectionGeneratedProps = {
    divDiv0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">> | ((item: BannerSectionBannerSlidesItem) => Partial<ComponentProps<"h1">>);
    divDiv0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BannerSectionBannerSlidesItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionBannerSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divH20H2Props?: Partial<ComponentProps<"h2">> | ((item: BannerSectionBannerTwosItem) => Partial<ComponentProps<"h2">>);
    /** Default: "Prev" */
    sectionDiv0Button0ButtonAriaLabel?: string;
    sectionDiv0Button0ButtonVisible?: boolean;
    sectionDiv0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "Next" */
    sectionDiv0Button1ButtonAriaLabel?: string;
    sectionDiv0Button1ButtonVisible?: boolean;
    sectionDiv0Button1ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Button1ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/skin-bg-01.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/skin-bg-02.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionSlider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    bannerSectionBannerSlides: BannerSectionBannerSlidesItem[];
    bannerSectionBannerSlidesItemWrapper?: (item: BannerSectionBannerSlidesItem, content: ReactNode) => ReactNode;
    bannerSectionBannerSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerSectionBannerSlidesLinkVisible?: boolean;
    bannerSectionBannerSlidesLinkRenderer?: (item: BannerSectionBannerSlidesItem, defaultNode: ReactNode) => ReactNode;
    bannerSectionBannerSlidesImageVisible?: boolean;
    bannerSectionBannerSlidesImageRenderer?: (item: BannerSectionBannerSlidesItem, defaultNode: ReactNode) => ReactNode;
    bannerSectionBannerSlidesH1Visible?: boolean;
    bannerSectionBannerSlidesH1Renderer?: (item: BannerSectionBannerSlidesItem, defaultNode: ReactNode) => ReactNode;
    bannerSectionBannerSlidesLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BannerSectionBannerSlidesItem) => Partial<ComponentProps<typeof SmartLink>>);
    bannerSectionBannerSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionBannerSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    bannerSectionBannerSlidesH1Props?: Partial<ComponentProps<"h1">> | ((item: BannerSectionBannerSlidesItem) => Partial<ComponentProps<"h1">>);
    bannerSectionBannerTwosItemWrapper?: (item: BannerSectionBannerTwosItem, content: ReactNode) => ReactNode;
    bannerSectionBannerTwosRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerSectionBannerTwosH2Visible?: boolean;
    bannerSectionBannerTwosH2Renderer?: (item: BannerSectionBannerTwosItem, defaultNode: ReactNode) => ReactNode;
    bannerSectionBannerTwosH2Props?: Partial<ComponentProps<"h2">> | ((item: BannerSectionBannerTwosItem) => Partial<ComponentProps<"h2">>);
    bannerSectionBannerTwos2ItemWrapper?: (item: BannerSectionBannerTwos2Item, content: ReactNode) => ReactNode;
    bannerSectionBannerTwos2Renderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeFourteenBannerSectionGenerated: FC<HomeFourteenBannerSectionGeneratedProps> = ({
    sectionDiv0Button0ButtonAriaLabel = "Prev",
    sectionDiv0Button0ButtonVisible,
    sectionDiv0Button0ButtonRenderer,
    sectionDiv0Button0ButtonProps,
    sectionDiv0Button1ButtonAriaLabel = "Next",
    sectionDiv0Button1ButtonVisible,
    sectionDiv0Button1ButtonRenderer,
    sectionDiv0Button1ButtonProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/skin-bg-01.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/skin-bg-02.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div0Div0Div0H10H1Props,
    divDiv0Div0Div0Div0Link0LinkProps,
    divDiv0Div0Div1Div0ImageWithBasePath0ImageProps,
    divH20H2Props,
    sectionSlider0SliderProps,
    bannerSectionBannerSlides,
    bannerSectionBannerSlidesItemWrapper,
    bannerSectionBannerSlidesRenderer,
    bannerSectionBannerSlidesLinkVisible,
    bannerSectionBannerSlidesLinkRenderer,
    bannerSectionBannerSlidesImageVisible,
    bannerSectionBannerSlidesImageRenderer,
    bannerSectionBannerSlidesH1Visible,
    bannerSectionBannerSlidesH1Renderer,
    bannerSectionBannerSlidesLinkProps,
    bannerSectionBannerSlidesImageProps,
    bannerSectionBannerSlidesH1Props,
    bannerSectionBannerTwosItemWrapper,
    bannerSectionBannerTwosRenderer,
    bannerSectionBannerTwosH2Visible,
    bannerSectionBannerTwosH2Renderer,
    bannerSectionBannerTwosH2Props,
    bannerSectionBannerTwos2ItemWrapper,
    bannerSectionBannerTwos2Renderer,
}) => {
    const sliderRef = useRef<Slider | null>(null);
    return (
        <section className="banner-section-fourteen">
            <Slider ref={sliderRef} {...settings} className="banner-slider-fourteen" {...(sectionSlider0SliderProps ?? {})}>
                {renderCollectionNode(
                    bannerSectionBannerSlides,
                    (item: BannerSectionBannerSlidesItem) => (
                        <div className={item.divClassName ?? "banner-slide"} key={item.key}>
                            <div className={item.div0ClassName2 ?? "container"}>
                                <div className={item.div0ClassName3 ?? "row align-items-end"}>
                                    <div className={item.className}>
                                        <div className={item.div0ClassName4 ?? "banner-content wow fadeInUp"} data-wow-delay={item.div0DataWowDelay ?? "0.2s"} data-wow-duration={item.div0DataWowDuration ?? "1s"}>
                                            {renderItemNode(bannerSectionBannerSlidesH1Visible, bannerSectionBannerSlidesH1Renderer, item, (
                                                <h1 {...(typeof bannerSectionBannerSlidesH1Props === "function" ? bannerSectionBannerSlidesH1Props(item) : (bannerSectionBannerSlidesH1Props ?? {}))} {...(typeof divDiv0Div0Div0Div0H10H1Props === "function" ? divDiv0Div0Div0Div0H10H1Props(item) : (divDiv0Div0Div0Div0H10H1Props ?? {}))}>
                                                    {item.h10Text}
                                                    <span className={item.span0ClassName ?? "section-line"}>{item.span0Text}</span>
                                                    {item.h10H10Text}
                                                    {" "}
                                                    <span className={item.span1ClassName ?? "subtitle"}>{item.span1Text}</span>
                                                </h1>
                                            ))}
                                            <p>{item.p0Text}</p>
                                            {renderItemNode(bannerSectionBannerSlidesLinkVisible, bannerSectionBannerSlidesLinkRenderer, item, (
                                                <SmartLink href={item.href ?? "all_routes.register"} className={item.link0ClassName ?? "btn btn-secondary theme-14-btn"} {...(typeof bannerSectionBannerSlidesLinkProps === "function" ? bannerSectionBannerSlidesLinkProps(item) : (bannerSectionBannerSlidesLinkProps ?? {}))} {...(typeof divDiv0Div0Div0Div0Link0LinkProps === "function" ? divDiv0Div0Div0Div0Link0LinkProps(item) : (divDiv0Div0Div0Div0Link0LinkProps ?? {}))}>
                                                    <i className={item.i0ClassName ?? "isax isax-calendar-tick5 me-2"} />
                                                    {item.link0Text}
                                                </SmartLink>
                                            ))}
                                            <div className="banner-wrap">
                                                {renderCollectionNode(
                                                    item.bannerWrapItems ?? [],
                                                    (item: BannerSectionBannerTwosItem) => (
                                                        <div className={item.className ?? "banner-item-two"} key={item.key}>
                                                            {renderItemNode(bannerSectionBannerTwosH2Visible, bannerSectionBannerTwosH2Renderer, item, (
                                                                <h2 {...(typeof bannerSectionBannerTwosH2Props === "function" ? bannerSectionBannerTwosH2Props(item) : (bannerSectionBannerTwosH2Props ?? {}))} {...(typeof divH20H2Props === "function" ? divH20H2Props(item) : (divH20H2Props ?? {}))}>
                                                                    <span className={item.span0ClassName ?? "count-digit"}></span>
                                                                    {item.h20Text}
                                                                </h2>
                                                            ))}
                                                            <p className={item.p0ClassName ?? "mb-0"}>{item.p0Text}</p>
                                                        </div>
                                                    ),
                                                    bannerSectionBannerTwosItemWrapper,
                                                    bannerSectionBannerTwosRenderer
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName}>
                                        <div className={item.div0ClassName}>
                                            {renderItemNode(bannerSectionBannerSlidesImageVisible, bannerSectionBannerSlidesImageRenderer, item, (
                                                <SmartImage src={item.src} className={item.imageWithBasePath0ClassName ?? "img-fluid banner-image"} alt={item.alt ?? "banner"} {...(typeof bannerSectionBannerSlidesImageProps === "function" ? bannerSectionBannerSlidesImageProps(item) : (bannerSectionBannerSlidesImageProps ?? {}))} {...(typeof divDiv0Div0Div1Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div1Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div1Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ),
                    bannerSectionBannerSlidesItemWrapper,
                    bannerSectionBannerSlidesRenderer
                )}
            </Slider>
            <div className="slide-btn">
                {renderNode(sectionDiv0Button0ButtonVisible, sectionDiv0Button0ButtonRenderer, (
                    <button type="button" className="slick-arrow ban-prev" aria-label={sectionDiv0Button0ButtonAriaLabel} {...(sectionDiv0Button0ButtonProps ?? {})}>
                        <i className="isax isax-arrow-left" />
                    </button>
                ))}
                {renderNode(sectionDiv0Button1ButtonVisible, sectionDiv0Button1ButtonRenderer, (
                    <button type="button" className="slick-arrow ban-next" aria-label={sectionDiv0Button1ButtonAriaLabel} {...(sectionDiv0Button1ButtonProps ?? {})}>
                        <i className="isax isax-arrow-right-1" />
                    </button>
                ))}
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="banner-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="banner-bg-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFourteenBannerSectionGenerated;
